import axios from 'axios'
import endpoints from '../../endpoints'

const API_URL = process.env.REACT_APP_API_URL

export async function fetchHolidayList() {
  try {
    const response = await axios.get(API_URL + endpoints.holidays.list)
    return response.data
  } catch (error) {
    throw error
  }
}
export async function createHoliday(body) {
  try {
    const response = await axios.put(API_URL + endpoints.holidays.create, body)
    return response.data
  } catch (error) {
    throw error
  }
}
export async function updateHoliday(body) {
  try {
    const response = await axios.put(API_URL + endpoints.holidays.update, body)
    return response.data
  } catch (error) {
    throw error
  }
}
export async function deleteHoliday(holidayId) {
  try {
    const response = await axios.delete(API_URL + endpoints.holidays.delete + holidayId)
    return response.data
  } catch (error) {
    throw error
  }
}
